import { Fragment, useState } from 'react';
import { Transition } from '@headlessui/react';
import InputDiv from '../inputDiv';
import CommentContent from './commentSection';
import { ICommentAPI } from '../../index';

interface ICommentCard {
  comment: ICommentAPI;
  deleteLoading?: boolean;
  onSubmit: (text: string) => void;
  onDelete: (data: any) => void;
  disableReply?: boolean;
  onLike: () => void;
  isModal?: boolean;
  onUpdate: (data: any) => void;
}

export default function CommentCard({
  comment,
  deleteLoading = false,
  onSubmit,
  onDelete,
  onLike,
  disableReply = false,
  isModal = false,
  onUpdate,
}: ICommentCard) {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <Fragment>
      <CommentContent
        onLike={onLike}
        data={comment}
        onReply={() => setOpen(!open)}
        disableReply={disableReply}
        isModal={isModal}
        onDelete={onDelete}
        deleteLoading={deleteLoading}
        onUpdate={onUpdate}
      />
      <Transition
        show={open}
        enter='transition-opacity duration-175'
        enterFrom='opacity-0'
        enterTo='opacity-100'
        leave='transition-opacity duration-200'
        leaveFrom='opacity-100'
        leaveTo='opacity-0'
      >
        {!disableReply && (
          <InputDiv
            onSubmit={(text: string) => {
              setOpen(false);
              onSubmit(text);
            }}
          />
        )}
      </Transition>
    </Fragment>
  );
}
